const riot = require('riot');

riot.tag2('atom-tag', '<div class="bg-label_weak border border-separator_opaque rounded-4 px4 fs10 lh15 text-label_high line-clamp-1"><span>#</span><span>{opts.label}</span></div>', 'atom-tag,[data-is="atom-tag"]{display:inline-block}', '', function(opts) {
});